import React from 'react';
import DriverLicenseNumberField from './DriverLicenseNumberField';
import DriverFirstNameField from './DriverFirstNameField';
import DriverLastNameField from './DriverLastNameField';
import {FormState, FormErrors} from '../interfaces';

interface DriverFieldsProps {
  form: FormState;
  errors: FormErrors;
  onValueChange: (name: string, value: string) => void;
  /** Whether Driver License Number is required for this asset type. Defaults to true. */
  requireLicense?: boolean;
}

/**
 * Convenience bundle rendering the three driver info fields together:
 * Driver License Number, Driver's First Name, and Driver's Last Name.
 *
 * This component exists purely for convenience to reduce boilerplate in
 * per-asset-type forms that render all three driver fields with the same layout.
 * For forms that need a different layout, ordering, or per-field required-ness,
 * import and use the individual field components directly:
 * - {@link DriverLicenseNumberField}
 * - {@link DriverFirstNameField}
 * - {@link DriverLastNameField}
 */
const DriverFields: React.FC<DriverFieldsProps> = ({form, errors, onValueChange, requireLicense = true}) => {
  return (
    <>
      <DriverLicenseNumberField
        value={form.driverLicenseNumber}
        onValueChange={onValueChange}
        error={errors.driverLicenseNumber}
        required={requireLicense}
      />
      <DriverFirstNameField
        value={form.driverFirstName}
        onValueChange={onValueChange}
        error={errors.driverFirstName}
        required
      />
      <DriverLastNameField
        value={form.driverLastName}
        onValueChange={onValueChange}
        error={errors.driverLastName}
        required
      />
    </>
  );
};

export default DriverFields;

